import React from "react";
import Header from "../components/Header";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Webbanner from "../Page-section/Webdevelopment/Webbanner";
import Webprocess from "../Page-section/Webdevelopment/Webprocess";

import { useSEO } from "../hooks/useSEO";

function Webdevelopment() {
  useSEO({
    title: "Best Web Development Company in Noida for High Growth",
    description:
      "Looking for the best Web Development Company in Noida? Get fast, secure, and scalable websites that boost traffic, conversions, and business growth today.",
    canonical: "https://empowerweb.in/web-development-company-in-noida",
    ogTitle: "Web Development Company in Noida,web development in noida",
    ogDescription:
      "Professional web development services for businesses in Noida and Delhi NCR. Custom solutions with latest technologies.",
    keywords:
      "Web Development Company in Noida,web development in noida, top web development companies in noida, ecommerce development company in noida,best web design company in noida",
  });
  return (
    <div>
      <Header />
      <Navbar />
      <main>
        <Webbanner />
        <Webprocess />
      </main>
      <Footer />
    
    </div>
  );
}

export default Webdevelopment;
